<template>
    <div class="col backgroundForm">
        <div class="col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Reportes Revistas y Juegos de Guerra</h4>        
                <hr>
                <p v-if="cDtsUser.role === 4">Unidad {{ cDtsUser.name_port.toUpperCase() }} </p>
                <p v-else>Reporte de juegos de Juegos de Guerra y Revistas realizadas por las Unidades </p>
            </div>

            <transition name="fade" mode="out-in">
                <div class="form-row" v-if="cDtsUser.role !== 4">
                    <div class="form-group col-12 col-md-6 offset-md-3">
                        <label for="nombre_embarcacion">Unidades</label>  
                                <!-- listar las capitanias -->
                        <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="unit_select">
                            <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                        </select>                         
                    </div>
                </div>
            </transition>
        </div>
        
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                
                <a class="nav-item nav-link active" id="nav-add-capitan" data-toggle="tab" href="#nav-reprint-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="file-pdf" /> Reportes Unidad</a>
                
                <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-print-cert" role="tab" aria-controls="nav-new" aria-selected="false" v-if="cDtsUser.roleAssign!=='OPERADOR'"><font-awesome-icon icon="user-plus" /> Reporte Individual</a>
            </div>
        </nav>
                
        <div class="tab-content" id="nav-tabContent">
            
            <div class="tab-pane fade show active" id="nav-reprint-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br><br>
                <h6 align="center">Reportes de Juegos de Guerra y Revistas de la Unidad</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Del : </label>
                            <datetime v-model="dts_print_unit.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="date_init_ordop">Al : </label>
                            <datetime v-model="dts_print_unit.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                    </div>
                    
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="mListCertificates">Buscar</button>

                        <div class="table-responsive" v-if="list_dia_unidad.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Unidad</th>
                                        <th>Revista/Juego Guerra</th>
                                        <th>Titulo</th>
                                        <th>Correlativo Sistema</th>
                                        <th><font-awesome-icon icon="file-pdf"/></th>
                                        <th><font-awesome-icon icon="file-pdf"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- aqui reimprimos el pdf de sistema -->
                                    <tr v-for="(revJuegoUnit, index) in list_dia_unidad" :key="revJuegoUnit.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ revJuegoUnit.unidad }}</span>
                                        </td>
                                        <td>{{ revJuegoUnit.descripcion_tipo }}</td>
                                        <td>{{ revJuegoUnit.titulo }}</td>
                                        <td>{{ revJuegoUnit.correlativo }}/{{ revJuegoUnit.gestion }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mReportI(revJuegoUnit.id_revista)">
                                                <font-awesome-icon icon="file-pdf"/>
                                            </button>
                                        </td>
                                        <td>
                                            <button class="btn btn-outline-success" @click="mVerDocumento(revJuegoUnit.id_revista)">
                                                <font-awesome-icon icon="file-pdf"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
            </div>
            <!-- tab de reimpresion certificado -->
            
            <div class="tab-pane fade show" id="nav-print-cert" role="tabpanel" aria-labelledby="nav-capitan-tab" v-if="cDtsUser.roleAssign!=='OPERADOR'">
                <br><br>
                <h6 align="center">Busqueda de Juegos de Guerra y Revistas de Personas</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    

                    <!-- busqueda de persona -->
                    <div>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch"  value="document" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="name">No. Documento
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombreEmbarcacion">{{ searchType }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchType" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchType }} </small>
                        </div>
                        
                        <transition>
                            <div class="form-row" v-if="list_person_ordop.length > 0">
                                <div class="form-group col-12 col-md-4 offset-md-2">
                                    <label for="date_init_ordop">Del : </label>
                                    <datetime v-model="dts_dia_person.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                
                                </div>
                                <div class="form-group col-12 col-md-4">
                                    <label for="date_init_ordop">Al : </label>
                                    <datetime v-model="dts_dia_person.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                
                                </div>
                            </div>
                        </transition>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaData">Buscar</button>

                        <div class="table-responsive" v-if="list_person_ordop.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>CI</th>
                                        <th><font-awesome-icon icon="file-pdf"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persReg, index) in list_person_ordop" :key="persReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persReg.complete }}</span>
                                        </td>
                                        <td>{{ persReg.identification }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mReportIndividual(persReg)">
                                                <font-awesome-icon icon="file-pdf"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
            </div>
            <!-- end first tab -->
            

            
        </div>
        <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
    </div>
    </template>
    
    <script>
    import Vue from 'vue';
    import axios from 'axios';
    import modalLoading from '../modal/modalLoading';
    const qs = require('qs');
    
    export default {
        name:'admin-user',
        data(){
            return{
                ports:[],
                captain_ordop_report:0,
                grados:[],
                especialidad:[],
                ordops_persona:[],
                ordops_seleccionados:[],
                tipos_certificado:[],
                dts_certificado:{
                    rubrica:'',
                    id_grado_jefe:0,
                    id_especialidad_jefe:0,
                    jefe:'',
                    subjefe:'',
                    division:'',
                    tipo_certificado:0,
                    motivo_solicitud:'',
                    id_division:0,
                    detalle_division:''
                },
                aux_division:{
                    id:0,
                    detail:''
                },
                animate:false,
                owner:{
                    id:0,
                    type_identification:null,
                    number_identification:null,
                    site_expedition:null,
                    name:null,
                    direction:null,
                    mobile:null,
                    phone:null,
                    partner:null,
                    nationality:null
                },
                person_edit:{
                    id:0,
                    complete:null,
                    identification:null,
                    site_expedition:null,
                    birthday:null,
                    grade:null,
                    phone:0,
                    speciality:null
                },
                list_person_ordop:[],
                d_owner_disabled:false,
                d_disabled_partner:false,
                d_owner_disabled_edit:false,
                d_disabled_partner_edit:false,
                types_identification:[],
                citys:[],
                countrys:[],
                status_send:true,
                modal_load_id:'id_owner_new',
                modal_load_title:'Cargando', 
                optionSearch:'name',
                data_person:null,
                dts_dia_person:{
                    date_init:null,
                    date_end:null
                },
                dts_print_unit:{
                    date_init:null,
                    date_end:null
                },
                correlative:{
                    co:0,
                    gestion:0,
                    id:0
                },
                list_dia_unidad:[],
                divisiones:[],
                unit_select:-1
            }
        },
        mounted(){
            this.getYears();
            this.chargeInit();
            this.callCaptains();
        },
        methods:{
            async callCaptains(){
                let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
                // console.log(cp);
                this.captain_report_ordop=this.cDtsUser.portId;
                this.ports=cp.data;
            },
            mReportI(id){
                // console.log(`el id es ${id}`);
                // this.title_modal='Descargando';
                
                // let route = this.$router.resolve({path: `pdfOrdopI/${id}?api_token=${Vue.auth.getToken()}`});
                let url_report=btoa(`pdfOrdopDia/${id}`)
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            },
            async mVerDocumento(idTask){
                console.log('viendo el documento adjunto de la ORDOP')
                let url_report=btoa(`pdfDocumentDia/${idTask}`)
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            },
            async mReportIndividual(persReg){
                // aqui solicitamos el kardex personal del usuario de todas sus revistas o juegos de guerra con los que cuenta
                
                let aux_inicio= this.dts_dia_person.date_init.split('T');
                let aux_final= this.dts_dia_person.date_end.split('T');
                
                // let reportIndividualDia=await axios.get();
                let url_report=btoa(`pdfDiaPersona/${persReg.identification}/${aux_inicio[0]}/${aux_final[0]}`)
                
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            },
            async mRecuperaDatos(){
                
                    let datos_certificado=await axios.get(`recuperaDatosDia?api_token=${Vue.auth.getToken()}`);
                    // console.log(datos_certificado);
                    this.dts_certificado.jefe=datos_certificado.data.director;
                    this.dts_certificado.id_grado_jefe=datos_certificado.data.id_grado_jefe;
                    this.dts_certificado.id_especialidad_jefe=datos_certificado.data.id_especialidad_jefe;
                    this.dts_certificado.subjefe=datos_certificado.data.subjefe;
                    this.dts_certificado.division=datos_certificado.data.jefe_division;
                    this.dts_certificado.rubrica=datos_certificado.data.rubrica!==null ?datos_certificado.data.rubrica:'';
                    this.dts_certificado.motivo_solicitud= datos_certificado.data.motivo_solicitud;
                
                    toastr.warning('Se ha devuelto una respuesta del Servidor, de lo contrario llene los campos');
                
            },
            async mCheckChange(event, dts){
                // aqui va al array de ordops elegidas
                if(event.target.checked){
                    this.ordops_seleccionados.push(dts);    
                    // this.$store.dispatch('sDebtsP/addDebts', dts);
                }else{
                    // this.$store.dispatch('sDebtsP/deleteItemDebts', event.target.id);
                    let ib= this.ordops_seleccionados.findIndex(dta=> dta.id_ordop === dts.id_ordop);
                    this.ordops_seleccionados.splice(ib, 1);
                }
                console.log(this.ordops_seleccionados);
            },
            async mBuscaOrdopsPersona(){
              //aqui buscamos a la persona y las ordenes de operaciones finalizadas comprendidas en el periodo señalado
              let aux_init= this.dts_dia_person.date_init.split('T');
              let aux_end= this.dts_dia_person.date_end.split('T');
              
               let reso= await axios.get(`revjuIndividually/${this.person_edit.number_identification}/${aux_init[0]}/${aux_end[0]}/P?api_token=${Vue.auth.getToken()}`);
               console.log(reso);
               if(reso.data.length>0){
                   this.ordops_persona=reso.data;
               }else{
                toastr.warning(`No se ha encontrado registros de la persona señalada en el periodo indicado`);
               }
            },
            mValidaCorrelativo(){
              if(this.dts_certificado.jefe.trim()===''){
                toastr.warning(`Indique el Nombre del Jefe de Departamento que firma`);
                return false;
              }
              if(this.dts_certificado.id_grado_jefe===0){
                toastr.warning(`Seleccione el grado correspondiente al Jefe de Departamento`);
                return false;
              }
              if(this.dts_certificado.id_especialidad_jefe===0){
                toastr.warning(`Selecciona la especialidad correspondiente al Jefe de Departamento`);
                return false;
              }
              if(this.dts_certificado.subjefe.trim()===''){
                toastr.warning(`Indique el Nombre del Sub-Jefe de Departamento que firma`);
                return false;
              }  
              if(this.dts_certificado.division.trim()===''){
                toastr.warning(`Indique el Nombre del Jefe de División que firma`);
                return false;
              }
              if(this.dts_certificado.motivo_solicitud.trim()===''){
                toastr.warning(`Indique Cual es el motivo de la solicitud de certificación`);
                return false;
              }
              if(this.dts_certificado.tipo_certificado===0){
                toastr.warning(`Seleccione un tipo de certificado`);
                return false;
              }
              
              if(this.dts_certificado.rubrica.length === 0 || this.dts_certificado.rubrica.trim() === ''){
                toastr.warning(`Indique las rubricas del certificado`);
                return false;
              }              
              return true;  
            },
            async mGenerateCorrelative(){
                // esta funcion registrara todo el certificado a generar en base de datos firma director, subjefe y otros
                if(this.mValidaCorrelativo()){
                    let dts={
                        id_person:this.person_edit.id,
                        complete:`${this.person_edit.grade} ${this.person_edit.speciality} ${this.person_edit.complete}`,
                        motivo:this.dts_certificado.motivo_solicitud,
                        fi:this.dts_dia_person.date_init,
                        ff:this.dts_dia_person.date_end,
                        jefe:this.dts_certificado.jefe,
                        id_grado_jefe:this.dts_certificado.id_grado_jefe,
                        id_especialidad_jefe:this.dts_certificado.id_especialidad_jefe,
                        subjefe:this.dts_certificado.subjefe,
                        division: this.dts_certificado.division,
                        rubrica: this.dts_certificado.rubrica,
                        tipo_certificado: this.dts_certificado.tipo_certificado,
                        ordops_seleccionadas:this.ordops_seleccionados,
                        detalle_division:this.aux_division.detail
                    }
                    let genCorrelative=await axios.post(`generateCorrelativeOrdopDia?api_token=${Vue.auth.getToken()}`,qs.stringify(dts));

                    // console.log(genCorrelative);
                    if(genCorrelative.data.status){
                        toastr.success('Exito', genCorrelative.data.respuesta);
                        this.correlative.co=genCorrelative.data.registro[0].correlativo;
                        this.correlative.gestion=genCorrelative.data.registro[0].gestion;
                        this.correlative.id=genCorrelative.data.registro[0].id;

                    }else{
                        toastr.error('Error', genCorrelative.data.respuesta);
                    }    
                }
                
            },
            getYears(){
                let ya=new Date();
                this.year_select=ya.getFullYear();
                this.month_select=ya.getMonth()+1;
                const init=2018;
                this.years=[];
                for(let i=init; i<=this.year_select; i++){
                    let ai={c:i};
                    this.years.push(ai);
                }
                let  today = new Date();
                let m = today.getMonth() + 1;
                let mes = (m < 10) ? '0' + m : m;
                let d = today.getDate();
                let dia= (d < 10) ? '0'+d : d;
                let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
                this.dts_dia_person.date_init=date_aux;
                this.dts_dia_person.date_end=date_aux;
                this.dts_print_unit.date_init=date_aux;
                this.dts_print_unit.date_end=date_aux; 
                // this.dts_dia_person.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
            },
            async chargeInit(){
                this.tipos_certificado=[];

                let respCert=await axios.get(`globals/tipocertificadoDia?api_token=${Vue.auth.getToken()}`);
                let divisiones = await axios.get(`globals/divisiones?api_token=${Vue.auth.getToken()}`);
                let grados_aux= await axios.get(`globals/grade?api_token=${Vue.auth.getToken()}`);
                let especialidad_aux= await axios.get(`globals/especiality?api_token=${Vue.auth.getToken()}`);
                // console.log(respCert.data);
                if(respCert.data.length>0){
                    this.tipos_certificado=respCert.data;
                    this.divisiones=divisiones.data;
                    this.grados=grados_aux.data;
                    this.especialidad=especialidad_aux.data;
                }else{
                    this.toastr.warning('Sin datos', 'No se ha encontrado Datos registrados en estas fechas')
                }
            },
            // aqui buscamos 25/03/2025 las revistas de la unidad
            async mListCertificates(){
                this.list_dia_unidad=[];
                
                let respJuegosrevista;
                if(this.cDtsUser.roleAssign!=='OPERADOR'){    
                    // verificar que se haya seleccionado una unidad
                    if(this.unit_select < 0){
                        toastr.warning('seleccione una Unidad para su busqueda');
                        return false;
                    }
                }else{
                    this.unit_select=this.cDtsUser.idPort;
                }
                respJuegosrevista=await axios.get(`getJuegoRevistaDia/${this.unit_select}/${this.dts_print_unit.date_init}/${this.dts_print_unit.date_end}?api_token=${Vue.auth.getToken()}`);
                console.log(respJuegosrevista.data);
                
                if(respJuegosrevista.data.length>0){
                        this.list_dia_unidad=respJuegosrevista.data;
                }else{
                        toastr.warning('No se ha encontrado Certificados registrados en estas fechas', 'Sin datos')
                }
            },            
            mReportPersonOrdop(idP=0){
            // aqui llamamos al reporte de millas de la persona de la CC.PP
                if(this.correlative.id!==0){
                    let url_report;
                    let adi=this.dts_dia_person.date_init.split('T');
                    this.dts_dia_person.date_init=adi[0];
                    let adf=this.dts_dia_person.date_end.split('T');
                    this.dts_dia_person.date_end=adf[0];

                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfICVDIA/${this.correlative.id}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('seleccione una persona', 'Advertencia');
                }
            },
            mReportPersonOrdopCaratula(idP=0){
                
            },
            mCloseEdit(){
                this.person_edit.id=0;
                this.person_edit.type_identification=0;
                this.person_edit.number_identification=0;
                this.person_edit.site_expedition=0;
                this.person_edit.name=null;
                this.person_edit.direction=null;
                this.person_edit.mobile=null;
                this.person_edit.phone=null;
                this.person_edit.partner=null;
                this.person_edit.nationality=0;
                this.ordops_seleccionados=[];
                this.ordops_persona=[];
                this.correlative.co=0;
                this.correlative.gestion=0;
                this.correlative.id=0;
            },
            mSelectPersonReport(sp){
                this.person_edit.id=sp.id;
                this.person_edit.number_identification=sp.identification;
                this.person_edit.complete=sp.complete;
                this.person_edit.mobile=sp.phone;
                this.person_edit.speciality=sp.speciality;
                this.person_edit.grade=sp.grade;
                // this.mChangeOwnerIdentificationEdit();
            },
            buscaData(){
                // console.log(`${this.optionSearch} tipo`);
                // console.log(`${this.data_person}`);
                this.ordops_persona=[];
                this.ordops_seleccionados=[];
                if(this.data_person !== null || this.data_person.trim().length > 0 ){
                    // console.log('enviando al servidor');
                    axios.get(`searchPersonCompleteType/${this.data_person}/${this.optionSearch}?api_token=${Vue.auth.getToken()}`)
                        .then((res) => {     
                            // console.log(res.data);               
                            this.list_person_ordop = res.data
                            // this.users = res.data.items
                        }).catch(error => {
                            console.log(error);
                        })
                }else{
                    toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
                }
            },
            mViewSearch(event){
                console.log(event);
                var radios=$("input[type=radio]").parents('label');
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                //console.log(radioV);
                this.optionSearch=radioV;
            },
            mProgressModal(){
                $('#'+this.modal_load_id).modal('show');
            },
            mCloseProgressModal(){
                $('#'+this.modal_load_id).modal('hide');
            },
            mSelectedOwner(data){
                // console.log(data);
                this.owner.id=data.id_propietario;
                this.owner.type_identification=data.tipo_identificacion;
                this.owner.number_identification=data.dato_identificacion;
                this.owner.site_expedition=data.id_expedido;
                this.owner.name=data.nombre_propietario;
                this.owner.direction=data.domicilio;
                this.owner.mobile=data.celular;
                this.owner.phone=data.telefono_fijo;
                this.owner.partner=data.representante_legal;
                this.owner.nationality=data.id_nacionalidad;
                this.d_owner_disabled=true;
                this.d_disabled_partner=true;
            },
            mResetRegisterOwner(){
                this.owner.id=0;
                this.owner.type_identification=null;
                this.owner.number_identification=null;
                this.owner.site_expedition=null;
                this.owner.name=null;
                this.owner.direction=null;
                this.owner.mobile=null;
                this.owner.phone=null;
                this.owner.partner=null;
                this.owner.nationality=null;
                this.d_owner_disabled=false;
                this.d_disabled_partner=false;
                this.ordops_seleccionados=[];
            },
            
        },
        components:{
            'modal-loading':modalLoading
        },
        computed:{
            searchType(){
                switch(this.optionSearch){
                    case 'name':
                        return 'Nombre de la Persona';
                    break;
    
                    case 'document':
                        return 'Documento de la Persona';
                    break;
                }
            },
            cDtsUser(){
                return this.$store.getters.getUserState;
            }
        },
        filters:{
            upperCase(value){
                return value.toUpperCase();
            }
        }
    }
    </script>
    
    <style>
        .required-text{
            color:red; 
            font-weight:bold;
        }
    </style>
    


// WEBPACK FOOTER //
// src/components/ordop/OrdopDiaReport.vue